"use client"

import React from "react"
import { NotificationItemTemplate } from "./NotificationItemTemplate"
import { FragmentType, graphql, useFragment } from "@/gql"
import { NotificationActor } from "./NotificationActor"
import { Text } from "@/elements"
import { JobPostingLocationType, UserNotificationFeedItem } from "@/gql/graphql"
import { useRouter } from "next-nprogress-bar"

const JobRecommendationFragment = graphql(`
  fragment JobRecommendation on StreamNotificationFeedAggregatedActivity {
    id
    isRead
    isSeen
    activities {
      id
      time
      actor {
        id
        name
        ...NotificationActor
      }
      object {
        __typename
        ... on JobPosting {
          id
          title
          locationType
          locationName
          position {
            id
            name
          }
        }
      }
    }
  }
`)

interface Props {
  onClick: (type: UserNotificationFeedItem) => void
  onActorClick: (e: React.MouseEvent<any, MouseEvent>) => void
  item: FragmentType<typeof JobRecommendationFragment>
}

export const JobRecommendation: React.FC<Props> = props => {
  const item = useFragment(JobRecommendationFragment, props.item)
  const router = useRouter()

  const { onActorClick, onClick } = props
  const activity = item.activities?.[0]
  const jobPosting =
    activity?.object?.__typename === "ClientJobPosting" || activity?.object?.__typename === "CreativeJobPosting"
      ? activity?.object
      : null

  const actor = activity?.actor
  const actorName = actor?.name

  const isRemote = jobPosting?.locationType === JobPostingLocationType.Telecommute

  const handleClick = () => {
    onClick(UserNotificationFeedItem.JobRecommendation)
    router.push(`/jobs/${jobPosting?.id}`)
  }

  if (!jobPosting) return null

  return (
    <NotificationItemTemplate
      isSeen={item.isSeen}
      onClick={handleClick}
      LeftComponent={actor && <NotificationActor actor={actor} onActorClick={onActorClick} />}
      TextContent={
        <Text element="span">
          <Text element="span" onClick={onActorClick} className="!font-medium">
            {actorName ?? "The client"}
          </Text>{" "}
          is hiring a <Text element="span">{jobPosting.position?.name ?? "position"}</Text>
          {isRemote ? " for a remote role" : jobPosting?.locationName ? ` in ${jobPosting?.locationName}` : ""}.
        </Text>
      }
      time={activity?.time}
    />
  )
}
